import { render, staticRenderFns } from "./GridProducts.vue?vue&type=template&id=6a99f8e8&"
import script from "./GridProducts.vue?vue&type=script&lang=js&"
export * from "./GridProducts.vue?vue&type=script&lang=js&"
import style0 from "./GridProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports